import { render, staticRenderFns } from "./educationDivisionEnv2.vue?vue&type=template&id=1e4b35d4"
import script from "./educationDivisionEnv2.vue?vue&type=script&lang=js"
export * from "./educationDivisionEnv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4b35d4')) {
      api.createRecord('1e4b35d4', component.options)
    } else {
      api.reload('1e4b35d4', component.options)
    }
    module.hot.accept("./educationDivisionEnv2.vue?vue&type=template&id=1e4b35d4", function () {
      api.rerender('1e4b35d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivisionEnv2.vue"
export default component.exports